import { Navigate, useLocation } from 'react-router-dom';
import i18n from 'i18next';

export const defaultLanguage = () => {
    // Currently, default language will be provided by i18Next library as selected or the fallback one
    // We can use this in the future to check for a country first, if i18n was not previously set using localStorage.getItem('i18nextLng');
    return i18n.language;
}

const LanguageRedirect = () => {
    const location = useLocation();
    
    // Path segments will contain an empty item in the first position because it starts with /
    const pathSegments = location.pathname.split('/');
    // Ignore an empty element and fetch element at index 1
    const lang = pathSegments[1];

    // Check if there is anything after domain name at a position reserved for a language and check if it is supported language
    if (lang && !i18n.options.supportedLngs.includes(lang)) {
        
        // Any path segment that is 2 characters long will be considered a potentially valid language
        // Anything longer than 2 characters will be considered as URL slug
        const isLanguage = lang.length === 2;
        console.debug(`Length of the lang variable is ${lang.length}. It is${isLanguage ? "" : " not"} considered a language`);

        // Create new path from default language used in i18next
        const newPath = [`/${defaultLanguage()}`, ...pathSegments.slice(isLanguage ? 2 : 1)].join('/');
        console.debug(`Redirect from ${lang} to ${newPath}`);
        return <Navigate to={newPath} replace />;
    }

    return null;
};

export default LanguageRedirect;
